import { TeamDetails } from '../../dashboard/team-list/team-detail/[teamId]';
import type { DynamicObjectInterface /*AttachmentImageBA*/ } from '../../../sdk/type';
import { DashboardProps } from '../dashboardConfig';

export interface ProgressType {
  weighingDate: Date;
  weight: number;
  bodyFat: number;
  muscleKilogram: number;
  checked: boolean;
}

export const MyTeam = (props: DashboardProps) => {
  const { index, campaignData, decodedData } = props;
  return (
    <TeamDetails
      dataCampaign={campaignData[index]}
      decodedData={decodedData}
      index={index}
      role={
        campaignData[index].enrollment.some((i: DynamicObjectInterface) => i.enrollmentType === 'COACH')
          ? 'COACH'
          : 'PARTICIPANT'
      }
      myTeamId={campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId}
    />
  );
};
